export default __webpack_public_path__ + "static/media/audio.6a213206.svg";